window.addEventListener('turbo:load', () => {
  const noticeNum = document.querySelector('[data-notice="js-notice-num"]');
  const noticeIcon = document.querySelector('[data-notice="js-notice-icon"]');
  noticeNum && noticeIcon ? (noticeNum.textContent > 0 ? noticeIcon.classList.add('is-active') : false) : false;
});
